import UnicoUtils from "./script-utils.js";

/**
 * ヘッダー制御
 */
export default class UnicoHeader extends HTMLElement {

  constructor() {
    super();

    this.initPCMenu();
    this.initSPMenu();
    this.initFixedHeader();
  }

  /**
   * PCメニューの初期化
   */
  initPCMenu() {
    // グロナビのホバーおよびクリックでメニュー表示
    const pcMenu = this.querySelectorAll(".unico-gnav-list-item");
    pcMenu.forEach((elem, index) => {
      elem.addEventListener('mouseover', (event) => {
        pcMenu.forEach((menu) => {
          menu.classList.remove("-is-active");
        });
        elem.classList.add('-is-active');
      });
      elem.addEventListener('mouseout', (event) => {
        elem.classList.remove('-is-active');
      });
      elem.addEventListener('click', (event) => {
        const submenu = elem.querySelector(".unico-megamenu, .unico-submenu");
        if (!submenu.contains(event.target)) {
          elem.classList.toggle('-is-active');
        }
      });
    })

  }

  /**
   * SPメニューの初期化
   */
  initSPMenu() {
    const spMenu = this.querySelector("[data-target-id=sp-menu]")
    const spMenuButton = this.querySelectorAll("[data-target-id=sp-menu-button]")
    const menuContent = this.querySelector(".unico-sp-menu-content")

    // SPメニューボタン
    spMenuButton.forEach((button) => {
      button.addEventListener("click", () => {
        spMenu.classList.toggle("-is-active");
        menuContent.scrollTop = 0;
        categoryMenu.classList.remove("-is-active");
      });
    });

    // SPの検索ボタン
    const spSearchButton = this.querySelectorAll("[data-target-id=search-button]")
    const searchArea = this.querySelector("[data-target-id=search-form-area]")
    const searchInput = searchArea?.querySelector('[type="search"]');
    let lastSearchToggleAt = 0;
    const SEARCH_SCROLL_GRACE_MS = 250;

    spSearchButton.forEach((button) => {
      button.addEventListener("click", () => {
        searchArea.classList.toggle("-is-active");
        lastSearchToggleAt = Date.now();
      });
    });
    window.addEventListener("scroll", () => {
      // クリック直後に iOS Safari が追加で送ってくる scroll イベントを無視
      if (Date.now() - lastSearchToggleAt < SEARCH_SCROLL_GRACE_MS) {
        return;
      }
      if (searchArea.classList.contains("-is-active")) {
        searchArea.classList.remove("-is-active");
        searchInput?.blur();
      }
    });
    document.addEventListener("click", (e) => {
      if (searchArea.classList.contains("-is-active") && !searchArea.contains(e.target)) {
        searchArea.classList.remove("-is-active");
        searchInput?.blur();
      }
    }, true);

    // カテゴリーレイヤー
    const categoryButton = this.querySelectorAll("[data-target-id=category-button]");
    const categoryMenu = this.querySelector("[data-target-id=menu-category-list]");
    const categoryContent = this.querySelector(".unico-sp-menu-layer-content")
    categoryButton.forEach((button) => {
      button.addEventListener("click", () => {
        categoryMenu.classList.toggle("-is-active");
        menuContent.scrollTop = 0;
        categoryContent.scrollTop = 0;
      })
    });

    // 範囲外をクリック
    const spMenuArea = this.querySelector(".unico-sp-menu-container");
    this.addEventListener("click", (e) => {
      if (spMenu.classList.contains("-is-active") && !spMenuArea.contains(e.target)) {
        spMenu.classList.remove("-is-active");
      }
    }, true);
  }

  /**
   * ヘッダー固定処理
   */
  initFixedHeader() {
    const body = document.querySelector('body');
    const headerElem = this.querySelector('.unico-header-content');
    const headerText = this.querySelector('.unico-header-message');

    const fixedHeader = () => {
      const headerHeight = headerElem.clientHeight + headerText.clientHeight;
      if (window.scrollY >= headerHeight) {
        body.style.marginTop = `${headerElem.clientHeight}px`;
        headerElem.style.top = `-${headerElem.clientHeight}px`;
        headerElem.classList.add('-is-fixed');
      } else {
        headerElem.style.top = 'auto';
        headerElem.classList.remove('-is-fixed');
        body.style.marginTop = `0px`;
      }
    }

    window.addEventListener('scroll', fixedHeader);
    window.addEventListener('resize', fixedHeader);
  }

}
